import type { ExperimentKey, ProbExperimentDef } from '../types';
import { mountClassicProblems } from './classic-problems';
import { mountConditionalBayes } from './conditional-bayes';
import { mountGaltonBoard } from './galton-board';
import { mountNamedDistributions } from './named-distributions';
import { mountNormalCalculator } from './normal-calculator';
import { mountRandomVariables } from './random-variables';
import { mountSampleSpaceLab } from './sample-space-lab';
import { mountSumsOfIid } from './sums-of-iid';

export const EXPERIMENTS: Record<ExperimentKey, ProbExperimentDef> = {
  'sample-space-lab': {
    labelKey: 'experiment.sample-space-lab.label',
    params: [],
    mount: mountSampleSpaceLab,
  },
  'conditional-bayes': {
    labelKey: 'experiment.conditional-bayes.label',
    params: [],
    mount: mountConditionalBayes,
  },
  'random-variables': {
    labelKey: 'experiment.random-variables.label',
    params: [],
    mount: mountRandomVariables,
  },
  'named-distributions': {
    labelKey: 'experiment.named-distributions.label',
    params: [],
    mount: mountNamedDistributions,
  },
  'galton-board': {
    labelKey: 'experiment.galton-board.label',
    params: [],
    mount: mountGaltonBoard,
  },
  'sums-of-iid': {
    labelKey: 'experiment.sums-of-iid.label',
    params: [],
    mount: mountSumsOfIid,
  },
  'normal-calculator': {
    labelKey: 'experiment.normal-calculator.label',
    params: [],
    mount: mountNormalCalculator,
  },
  'classic-problems': {
    labelKey: 'experiment.classic-problems.label',
    params: [],
    mount: mountClassicProblems,
  },
};
